import { EOrgType } from '@unfoldrtech/portal-mic'
import {
  EChannelTypeGlobal,
  EReportColumnHeader1,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { TGlobalMetrics } from '../models'

export const getDefaultMetric = ({
  orgType,
  channelType,
  hasRevenue,
  allowedMetricList,
}: {
  orgType: EOrgType
  channelType?: EChannelTypeGlobal
  hasRevenue?: boolean
  allowedMetricList: (TGlobalMetrics | undefined)[]
}) => {
  if (
    (!channelType || channelType === EChannelTypeGlobal.DisplayAd) &&
    !allowedMetricList.includes(EReportColumnHeader1.Impressions)
  ) {
    return EReportColumnHeader1.Carts
  }

  // All retailer pages should default to Costs
  if (orgType === EOrgType.Retailer) {
    if (allowedMetricList.includes(EReportColumnHeader1.Costs)) {
      return EReportColumnHeader1.Costs
    }

    return EReportColumnHeader1.Impressions
  }

  // All advertiser pages without channelType or channel type SP should default to Revenue
  if (
    (!channelType || channelType === EChannelTypeGlobal.SponsoredProduct) &&
    hasRevenue &&
    allowedMetricList.includes(EReportColumnHeader1.Revenue)
  ) {
    return EReportColumnHeader1.Revenue
  }

  return EReportColumnHeader1.Impressions
}
